import React from "react";

function Icon({ icon, id }) {
    return(
        <i className={ icon } id={ id }></i>
    );
}

export default Icon;